import { FC, CSSProperties } from 'react';

type TrashIconProps = {
  style?: CSSProperties;
  className?: string;
};

const DeleteTrashBinIcon: FC<TrashIconProps> = ({ style, className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={ style }
      className={ className }
    >
      <path
        // eslint-disable-next-line max-len
        d="M0.75 2.75H14.75M6.25 11.25V6.25M9.25 11.25V6.25M9.25 0.75H6.25C5.98478 0.75 5.73043 0.855357 5.54289 1.04289C5.35536 1.23043 5.25 1.48478 5.25 1.75V2.75H10.25V1.75C10.25 1.48478 10.1446 1.23043 9.95711 1.04289C9.76957 0.855357 9.51522 0.75 9.25 0.75ZM12.3267 13.8327C12.3059 14.0827 12.1919 14.3159 12.0073 14.4858C11.8227 14.6557 11.5809 14.75 11.33 14.75H4.17067C3.91975 14.75 3.67798 14.6557 3.49336 14.4858C3.30874 14.3159 3.19474 14.0827 3.174 13.8327L2.25 2.75H13.25L12.3267 13.8327Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteTrashBinIcon;
